import { render, staticRenderFns } from "./JobDefinitionInitiators.vue?vue&type=template&id=67246060&scoped=true"
import script from "./JobDefinitionInitiators.vue?vue&type=script&lang=js"
export * from "./JobDefinitionInitiators.vue?vue&type=script&lang=js"
import style0 from "./JobDefinitionInitiators.vue?vue&type=style&index=0&id=67246060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67246060",
  null
  
)

export default component.exports